import { QUICK_VUE_IMAGES } from '../quickVueConfig';

let cardNumberCounter = 1;
let questionIdCounter = 1;

const HOUSE_FEATURES_PAGE_TITLE = `Thanks for confirming!  Does your house have any of these features?`;
const OUTBUILDINGS_TITLE = 'Outbuildings';
const SWIMMING_POOL_TITLE = 'Swimming Pool';
const TRAMPOLINE_TITLE = 'Trampoline';
const WOOD_STOVE_TITLE = 'Wood Stove';
const FINISHED_BASEMENT_TITLE = 'Finished Basement';

export const selfInspectQuestions = [
  {
    cardNumber: cardNumberCounter++, // 1
    allowResume: false,
    type: 'title',
    answerValue: null,
    hideDevButton: true,
    hideActions: false,
    hideBackButton: true,
    navLabel: `Let's get started!`,
    //
    questionLabel: (step, stepIndex, selfInspectInfo) =>
      `Hi there! ${selfInspectInfo.clientName} and ${selfInspectInfo.agencyName} need your help in finalizing your policy by providing us with a few additional details and pictures of your home.`,
    questionLabel2: (step, stepIndex, selfInspectInfo) =>
      `Please be sure to take exterior photos during daylight hours and to use flash for interior photos as needed.`,
    questionImage: (step, stepIndex, selfInspectInfo) =>
      `https://jmistorage.blob.core.windows.net/clientid-${selfInspectInfo.clientId}/logo.jpg`,
  },
  {
    cardNumber: cardNumberCounter++, // 2
    allowResume: false,
    type: 'yesno-edit',
    showInput: true,
    questionId: 239,
    edited: false,
    questionImage: QUICK_VUE_IMAGES.PLACEHOLDER,
    questionLabel: 'First things first, is this your address?',
  },
  {
    cardNumber: cardNumberCounter++, // 3
    allowResume: false,
    type: 'multi-input',
    title: `Great! Let's confirm a few more details`,
    continueButtonText: 'Looks good!',
    navLabel: `Keep going!`,
    navLabelDisabled: `Details please!`,
    questions: [
      {
        type: 'number',
        questionLabel: 'Year built',
        questionId: 242,
        pattern: '\\d*',
        maxLength: 4,
        minLength: 4,
      },
      {
        type: 'number',
        questionLabel: 'Finished Square Footage (Excluding Basement)',
        questionId: 4914,
        pattern: '\\d*',
        minLength: 3,
      },
      {
        type: 'select',
        questionLabel: 'Roof Age',
        questionId: 2434,
        options: [
          {
            label: '0 - 4 years',
            value: 11061,
          },
          {
            label: '5 - 10 years',
            value: 11062,
          },
          {
            label: '11 - 14 years',
            value: 11063,
          },
          {
            label: '15+ years',
            value: 11064,
          },
        ],
      },
      {
        type: 'select',
        questionLabel: 'Occupancy',
        questionId: 2285,
        options: [
          {
            label: 'Owner',
            value: 2196,
          },
          {
            label: 'Tenant',
            value: 7,
          },
          {
            label: 'Vacant',
            value: 1041,
          },
          {
            label: 'Seasonal',
            value: 1979,
          },
        ],
      },
    ],
  },

  {
    cardNumber: cardNumberCounter++, // 4
    allowResume: true,
    type: 'image-checkboxes',
    title: HOUSE_FEATURES_PAGE_TITLE,
    continueButtonText: 'Keep going!',
    questions: [
      {
        questionId: 261,
        type: 'checkbox',
        questionLabel: FINISHED_BASEMENT_TITLE,
        questionImage: QUICK_VUE_IMAGES.LIVING_ROOM_SQUARE,
        answerValue: false,
      },
      {
        questionId: 9920,
        type: 'checkbox',
        questionLabel: WOOD_STOVE_TITLE,
        questionImage: QUICK_VUE_IMAGES.WOOD_STOVE,
        answerValue: false,
      },
      {
        questionId: 9921,
        type: 'checkbox',
        questionLabel: OUTBUILDINGS_TITLE,
        questionImage: QUICK_VUE_IMAGES.EXPOSURE_OUTBUILDING,
        answerValue: false,
      },
      {
        questionId: 350,
        type: 'checkbox',
        questionLabel: SWIMMING_POOL_TITLE,
        questionImage: QUICK_VUE_IMAGES.EXPOSURE_POOL,
        answerValue: false,
      },
      {
        questionId: 363,
        type: 'checkbox',
        questionLabel: TRAMPOLINE_TITLE,
        questionImage: QUICK_VUE_IMAGES.EXPOSURE_TRAMPOLINE,
        answerValue: false,
      },
    ],
  },

  {
    cardNumber: cardNumberCounter++, // 5
    allowResume: true,
    type: 'title',
    questionImage: QUICK_VUE_IMAGES.HOUSE_FRONT,
    questionLabel: 'Time to get some fresh air!',
    questionLabel2: 'We need a few pictures of the outside of your house! Please take photos during daylight hours.',
    // questionLabel3: 'Please take photos during daylight hours.',
    navLabel: `Let's get started!`,
  },

  {
    cardNumber: cardNumberCounter++, // 6
    allowResume: true,
    questionId: 9925,
    type: 'take-picture',
    questionImage: QUICK_VUE_IMAGES.HOUSE_FRONT_LEFT,
    questionLabel: `Great! Let's get a corner picture that shows the FRONT and SIDE of your house!`,
    answerValue: null,
    shortLabel: 'Front & side',
  },
  {
    cardNumber: cardNumberCounter++, // 7
    allowResume: true,
    questionId: 7110,
    type: 'take-picture',
    questionImage: QUICK_VUE_IMAGES.HOUSE_ROOF_CLOSEUP,
    questionLabel: `Let's get some close-ups of the roof!`,
    questionLabel2: `(Zoomed in, no need to get a ladder!)`,
    answerValue: null,
    shortLabel: 'Roof',
  },
  {
    cardNumber: cardNumberCounter++, // 8
    allowResume: true,
    questionId: 9926,
    type: 'take-picture',
    questionImage: QUICK_VUE_IMAGES.HOUSE_REAR_RIGHT,
    questionLabel: `Now we need one that shows the OPPOSITE SIDE and BACK of the house!`,
    answerValue: null,
    shortLabel: 'Back and side',
  },

  {
    cardNumber: cardNumberCounter++, // 9
    allowResume: true,
    questionId: 7719,
    type: 'take-picture',
    multiple: true,
    showIf: (steps, step, index) => {
      return steps
        ?.find(s => s.title === HOUSE_FEATURES_PAGE_TITLE)
        ?.questions.find(q => q.questionLabel === OUTBUILDINGS_TITLE)?.answerValue;
    },
    questionImage: QUICK_VUE_IMAGES.EXPOSURE_OUTBUILDING,
    questionLabel: `You indicated that your house has outbuildings, let's get some pictures of those!`,
    answerValue: null,
    shortLabel: 'Outbuildings',
  },
  {
    cardNumber: cardNumberCounter++, // 10
    allowResume: true,
    questionId: 9927,
    type: 'take-picture',
    showIf: (steps, step, index) => {
      return steps
        ?.find(s => s.title === HOUSE_FEATURES_PAGE_TITLE)
        ?.questions.find(q => q.questionLabel === SWIMMING_POOL_TITLE)?.answerValue;
    },
    questionImage: QUICK_VUE_IMAGES.EXPOSURE_POOL,
    questionLabel: `You indicated that your house has a swimming pool, let's get a picture of that!`,
    answerValue: null,
    shortLabel: 'Swimming Pool',
  },
  {
    cardNumber: cardNumberCounter++, // 11
    allowResume: true,
    questionId: 9928,
    type: 'take-picture',
    showIf: (steps, step, index) => {
      return steps
        ?.find(s => s.title === HOUSE_FEATURES_PAGE_TITLE)
        ?.questions.find(q => q.questionLabel === TRAMPOLINE_TITLE)?.answerValue;
    },
    questionImage: QUICK_VUE_IMAGES.EXPOSURE_TRAMPOLINE,
    questionLabel: `You indicated that your house has a trampoline, let's get a picture of that!`,
    answerValue: null,
    shortLabel: 'Trampoline',
  },

  {
    cardNumber: cardNumberCounter++, // 12
    allowResume: true,
    questionId: 9923,
    type: 'yesno',
    questionImage: QUICK_VUE_IMAGES.RENOVATIONS,
    questionLabel: 'Have there been any major renovations in the last 5 years?',
  },
  {
    cardNumber: cardNumberCounter++, // 13
    allowResume: true,
    type: 'textarea',
    showIf: (steps, step, index) => {
      return steps.find(q => q.questionId === 9923)?.answerValue;
    },
    inputType: 'textarea',
    questionId: 9924,
    questionImage: QUICK_VUE_IMAGES.RENOVATIONS,
    questionLabel: 'Awesome! Can you tell us about the renovations?',
  },
  {
    cardNumber: cardNumberCounter++, // 14
    allowResume: true,
    questionId: 9940,
    type: 'take-picture',
    showIf: (steps, step, index) => {
      return steps.find(q => q.questionId === 9923)?.answerValue;
    },
    questionImage: QUICK_VUE_IMAGES.RENOVATIONS,
    // questionLabel: 'Photo op! Can you snap a picture of your main living area?',
    questionLabel: "Let's get some pictures of the renovations!",
    //questionLabel2: '(your choice)',
    answerValue: null,
    shortLabel: 'Renovations',
  },
  {
    cardNumber: cardNumberCounter++, // 15
    allowResume: true,
    questionId: 9922,
    type: 'yesno',
    questionImage: QUICK_VUE_IMAGES.REAL_DOGS,
    questionLabel: 'We love our dogs!',
    questionLabel2: 'Do you happen to have any there?',
  },
  {
    cardNumber: cardNumberCounter++, // 16
    allowResume: true,
    questionId: 9801,
    type: 'image-checkboxes',
    showIf: (steps, step, index) => {
      return steps[index - 1]?.answerValue;
    },
    title: `We bet they're cute!`,
    subtitle: 'Do you have any of the following breeds?',
    questions: [
      {
        // this is actually `answerValueId` but we're using it as a questionId
        questionId: 2640,
        type: 'checkbox',
        questionLabel: 'Akita',
        questionImage: QUICK_VUE_IMAGES.DOG_AKITA,
        answerValue: false,
      },
      {
        questionId: 2641,
        type: 'checkbox',
        questionLabel: 'Alaskan Malamute',
        questionImage: QUICK_VUE_IMAGES.DOG_ALASKAN_MALAMUTE,
        answerValue: false,
      },
      {
        questionId: 2642,
        type: 'checkbox',
        questionLabel: 'American Staffordshire Terrier',
        questionImage: QUICK_VUE_IMAGES.DOG_AMERICAN_STAFFORDSHIRE_TERRIER,
        answerValue: false,
      },
      {
        questionId: 2647,
        type: 'checkbox',
        questionLabel: 'Boxer',
        questionImage: QUICK_VUE_IMAGES.DOG_BOXER,
        answerValue: false,
      },
      {
        questionId: 2651,
        type: 'checkbox',
        questionLabel: 'Chow-Chow',
        questionImage: QUICK_VUE_IMAGES.DOG_CHOW_CHOW,
        answerValue: false,
      },
      {
        questionId: 2655,
        type: 'checkbox',
        questionLabel: 'Dalmatian',
        questionImage: QUICK_VUE_IMAGES.DOG_DALMATION,
        answerValue: false,
      },
      {
        questionId: 2656,
        type: 'checkbox',
        questionLabel: 'Doberman Pinscher',
        questionImage: QUICK_VUE_IMAGES.DOG_DOBERMAN_PINSCHER,
        answerValue: false,
      },
      {
        questionId: 2661,
        type: 'checkbox',
        questionLabel: 'German Shepherd',
        questionImage: QUICK_VUE_IMAGES.DOG_GERMAN_SHEPHERD,
        answerValue: false,
      },
      {
        questionId: 2665,
        type: 'checkbox',
        questionLabel: 'Husky',
        questionImage: QUICK_VUE_IMAGES.DOG_HUSKY,
        answerValue: false,
      },
      {
        questionId: 2668,
        type: 'checkbox',
        questionLabel: 'Mastiff',
        questionImage: QUICK_VUE_IMAGES.DOG_MASTIFF,
        answerValue: false,
      },
      {
        questionId: 2676,
        type: 'checkbox',
        questionLabel: 'Pit Bull',
        questionImage: QUICK_VUE_IMAGES.DOG_PIT_BULL,
        answerValue: false,
      },
      {
        questionId: 2679,
        type: 'checkbox',
        questionLabel: 'Presa Canario',
        questionImage: QUICK_VUE_IMAGES.DOG_PRESA_CANARIO,
        answerValue: false,
      },
      {
        questionId: 2681,
        type: 'checkbox',
        questionLabel: 'Rottweiler',
        questionImage: QUICK_VUE_IMAGES.DOG_ROTTWEILER,
        answerValue: false,
      },
      {
        questionId: 2689,
        type: 'checkbox',
        questionLabel: 'Staffordshire Bull',
        questionImage: QUICK_VUE_IMAGES.DOG_STAFFORDSHIRE_BULL,
        answerValue: false,
      },
      {
        questionId: 2696,
        type: 'checkbox',
        questionLabel: 'Wolf Hybrid (Wolf Dog)',
        questionImage: QUICK_VUE_IMAGES.DOG_DOG_WOLF_HYBRID,
        answerValue: false,
      },
      {
        questionId: 12,
        type: 'checkbox',
        questionLabel: 'Other',
        questionImage: QUICK_VUE_IMAGES.DOG_OTHER,
        answerValue: false,
      },
    ],
  },
  {
    cardNumber: cardNumberCounter++, // 17
    allowResume: true,
    questionId: 9936,
    type: 'take-picture',
    showIf: (steps, step, index) => {
      return steps.find(q => q.questionId === 9922)?.answerValue;
    },
    questionImage: QUICK_VUE_IMAGES.REAL_DOGS,
    questionLabel: `Great! Can you take a picture of your dog(s) for us?`,
    answerValue: null,
    shortLabel: 'Dogs',
  },
  // {
  //   cardNumber: cardNumberCounter++,
  //   allowResume: true,
  //   questionId: 1469,
  //   type: 'take-picture',
  //   questionImage: QUICK_VUE_IMAGES.LIVING_ROOM,
  //   // questionLabel: 'Photo op! Can you snap a picture of your main living area?',
  //   questionLabel: 'Can you snap some pictures of your living room?',
  //   //questionLabel2: '(your choice)',
  //   answerValue: null,
  // },
  {
    cardNumber: cardNumberCounter++,
    allowResume: true,
    questionId: 1468,
    type: 'take-picture',
    questionImage: QUICK_VUE_IMAGES.KITCHEN,
    // questionLabel: 'Photo op! Can you snap a picture of your main living area?',
    questionLabel: 'Can you snap some pictures of your kitchen?',
    //questionLabel2: '(your choice)',
    answerValue: null,
    shortLabel: 'Kitchen',
  },
  {
    cardNumber: cardNumberCounter++,
    allowResume: true,
    questionId: 7709,
    type: 'take-picture',
    //multiple: true,
    showIf: (steps, step, index) => {
      return steps
        ?.find(s => s.title === HOUSE_FEATURES_PAGE_TITLE)
        ?.questions.find(q => q.questionLabel === FINISHED_BASEMENT_TITLE)?.answerValue;
    },
    questionImage: QUICK_VUE_IMAGES.LIVING_ROOM,
    questionLabel: `You indicated that your house has a finished basement, let's get some pictures of that!`,
    answerValue: null,
    shortLabel: 'Basement',
  },
  {
    cardNumber: cardNumberCounter++,
    allowResume: true,
    questionId: 7718,
    type: 'take-picture',
    questionImage: QUICK_VUE_IMAGES.ELECTRIC_PANEL,
    // questionLabel: 'So much room for activities! Ok, now we need a picture of the electric panel!',
    questionLabel: 'Ok, now we need a picture of the main electric panel, with the cover OPEN!',
    answerValue: null,
    shortLabel: 'Electric panel',
  },
  {
    cardNumber: cardNumberCounter++,
    allowResume: true,
    questionId: 1472,
    type: 'take-picture',
    questionImage: QUICK_VUE_IMAGES.WATER_HEATER,
    questionLabel: `Almost done!`,
    questionLabel2: `Let's get a picture of the water heater!`,
    answerValue: null,
    shortLabel: 'Water heater',
  },
  {
    cardNumber: cardNumberCounter++,
    allowResume: true,
    questionId: 6873,
    type: 'take-picture',
    showIf: (steps, step, index) => {
      return steps
        ?.find(s => s.title === HOUSE_FEATURES_PAGE_TITLE)
        ?.questions.find(q => q.questionLabel === WOOD_STOVE_TITLE)?.answerValue;
    },
    questionImage: QUICK_VUE_IMAGES.WOOD_STOVE,
    questionLabel: `You indicated that your house has a wood stove, let's get a picture of that!`,
    answerValue: null,
    shortLabel: 'Wood stove',
  },
  {
    cardNumber: cardNumberCounter++,
    allowResume: true,
    questionId: 10003,
    type: 'take-picture',
    showIf: (steps, step, index) => {
      return steps
        ?.find(s => s.title === HOUSE_FEATURES_PAGE_TITLE)
        ?.questions.find(q => q.questionLabel === WOOD_STOVE_TITLE)?.answerValue;
    },
    questionImage: QUICK_VUE_IMAGES.WOOD_STOVE,
    questionLabel: `Please take a photo of the manufacturer label on the woodstove`,
    answerValue: null,
    shortLabel: 'Wood stove manufacturer',
  },
  {
    cardNumber: cardNumberCounter++,
    allowResume: true,
    type: 'multi-input',
    title: `Great! Let's confirm a few more details about the stove!`,
    continueButtonText: 'Looks good!',
    navLabel: `Keep going!`,
    navLabelDisabled: `Details please!`,
    showIf: (steps, step, index) => {
      return steps
        ?.find(s => s.title === HOUSE_FEATURES_PAGE_TITLE)
        ?.questions.find(q => q.questionLabel === WOOD_STOVE_TITLE)?.answerValue;
    },
    questions: [
      {
        type: 'number',
        questionLabel: 'What year was the woodstove installed?',
        questionId: 9999,
        pattern: '\\d*',
        maxLength: 4,
        minLength: 4,
      },
      {
        type: 'select',
        questionLabel: 'Was the woodstove professionally installed?',
        questionId: 7743,
        options: [
          {
            label: 'No',
            value: 4,
          },
          {
            label: 'Yes',
            value: 3,
          },
        ],
      },
      {
        type: 'select',
        questionLabel: 'Is the woodstove cleaned/inspected annually by a professional service?',
        questionId: 10000,
        options: [
          {
            label: 'No',
            value: 4,
          },
          {
            label: 'Yes',
            value: 3,
          },
        ],
      },
      {
        type: 'select',
        questionLabel: 'Does the woodstove sit on a non-combustible surface? (Cement, stone, brick, asbestos mat)?',
        questionId: 10001,
        options: [
          {
            label: 'No',
            value: 4,
          },
          {
            label: 'Yes',
            value: 3,
          },
        ],
      },
      {
        type: 'select',
        questionLabel:
          'Is there a minimum 36” clearance from any combustible materials or objects, on all sides of unit?',
        questionId: 10002,
        options: [
          {
            label: 'No',
            value: 4,
          },
          {
            label: 'Yes',
            value: 3,
          },
        ],
      },
    ],
  },

  {
    cardNumber: cardNumberCounter++,
    allowResume: false,
    type: 'title',
    hideActions: false,
    answerValue: null,
    hideDevButton: true,
    hideBackButton: false,
    handleUnfinishedUploads: true,
    questionImage: '', //QUICK_VUE_IMAGES.CLIENT_LOGO,
    // questionLabel: 'Please wait while we finish some things up...',
    //questionLabel2: 'You can now close this window',
    navLabel: `Finish Survey!`,
    //
    questionLabel: (step, stepIndex, selfInspectInfo) => `Please press "Finish Survey" to submit your response.`,
    questionImage: (step, stepIndex, selfInspectInfo) =>
      `https://jmistorage.blob.core.windows.net/clientid-${selfInspectInfo.clientId}/logo.jpg`,
  },

  {
    cardNumber: cardNumberCounter++,
    allowResume: false,
    type: 'title',
    hideActions: true,
    answerValue: null,
    hideDevButton: true,
    hideBackButton: true,
    //questionImage: QUICK_VUE_IMAGES.CLIENT_LOGO,
    questionLabel: 'Your survey has been received, you can now close this window.',
    //questionLabel2: 'You can now close this window',
    questionImage: (step, stepIndex, selfInspectInfo) =>
      `https://jmistorage.blob.core.windows.net/clientid-${selfInspectInfo.clientId}/logo.jpg`,
  },
];

export const selfInspectError = [
  {
    cardNumber: 1,
    type: 'title',
    answerValue: null,
    hideDevButton: true,
    hideActions: true,
    navLabel: ``,
    questionLabel: `We can't seem to find your survey, it may have already been submitted or the link has expired. If you have questions, please email service@jmireports.com or call us at <nobr><a href="tel:+14406288304">(440) 628-8304</a></nobr>.`,
    questionLabel2: 'error',
    questionImage: QUICK_VUE_IMAGES.BLUESKY,
    questionImage: (step, stepIndex, selfInspectInfo) =>
      `https://jmistorage.blob.core.windows.net/clientid-${selfInspectInfo.clientId}/logo.jpg`,
  },
];
